import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import { ProcurementAxios } from "api/ProcurementAxios";
import { DistrictInChargeAxios } from "api/DistrictInChargeAxios";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};

export const fetchPackingDone = createAsyncThunk(
  "PackingDone/fetchPackingDone",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }
    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // Handle cases like { from_date: ..., to_date: ... }
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
                if (
                  (filterValue.from_date || filterValue.to_date) &&
                  (filterField === "created_at" || filterField === "updated_at")
                ) {
                  if (filterField === "created_at") {
                    filterField = "created";
                  } else {
                    filterField = "updated";
                  }
                  params.append("filter_by", filterField);
                }
              });
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }
    const response: any = await Axios.get(
      `${
        process.env.REACT_APP_DISTCRICT_INCHARGE_PACKING_BACKEND_URL
      }district_packing/packing/packing_done_filter_list/?${params.toString()}`
    );

    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const exportCSVPackingDone = createAsyncThunk(
  "suppliers/exportCSVPackingDone",
  async (
    {
      filters,
    }: {
      filters?: ColumnFiltersState;
    },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
      };

      const params: Record<string, any> = {
        export: "csv",
      };

      if (filters && Array.isArray(filters)) {
        filters.forEach(({ id, value }) => {
          if (!id || value === undefined || value === "") return;

          if (
            (id === "updated_at" || id === "created_at") &&
            typeof value === "object" &&
            value !== null
          ) {
            const { from_date, to_date } = value as {
              from_date?: string;
              to_date?: string;
            };
            if (from_date) params["from_date"] = from_date;
            if (to_date) params["to_date"] = to_date;
            params["filter_by"] = id;
          } else if (
            typeof value === "object" &&
            value !== null &&
            (value as Record<string, any>)[id]
          ) {
            params[id] = (value as Record<string, any>)[id];
          } else {
            params[id] = value;
          }
        });
      }

      const response = await Axios.get(
        `${process.env.REACT_APP_DISTCRICT_INCHARGE_PACKING_BACKEND_URL}district_packing/packing/packing_done_filter_list/?export=excel`,
        {
          headers,
          params,
          responseType: "blob",
        }
      );

      return {
        blob: response.data,
        filename:
          response.headers["content-disposition"]
            ?.split("filename=")[1]
            ?.replace(/"/g, "") || "Packing Done.csv",
      };
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to export CSV");
    }
  }
);

export const fetchAllDropdownsPackingDone = createAsyncThunk(
  "PackingDone/fetchAllDropdownsPackingDone",
  async (column: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_DISTCRICT_INCHARGE_PACKING_BACKEND_URL}district_incharge_inventory/Transfer_request_dropdown/`,
        { params: { columns: column } }
      );

      const dropdownData = response.data?.data || response.data || [];

      return { column, data: dropdownData };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch dropdown");
    }
  }
);

export const fetchPackingDoneViewetails = createAsyncThunk(
  "PackingDone/fetchPackingDoneViewetails",
  async (packing_done_id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_DISTCRICT_INCHARGE_PACKING_BACKEND_URL}district_packing/packing/get_di_PackingDone_id/${packing_done_id}/`
      );
      // const response = await ProcurementAxios.get(`/approved-pr/831a7a4e-bfe4-43dd-b7ac-141d9daa7b2b/`);
      return response.data?.data;
    } catch (error: any) {
      console.error("Error fetching fetchPackingDoneViewetails", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch Packing Done details"
      );
    }
  }
);
